import { ComponentsLocaleTypes } from '../locales.types'

const componentsLocaleNn: ComponentsLocaleTypes = {
  character: {
    avatar: {
      comingSoon: 'Kjem snart'
    },
    input: {
      nameReady: 'Namn klart!'
    },
    layout: {
      header: {
        title: 'Vel din karakter',
        backbutton: 'Tilbake til forrige side',
        questionButton: 'Har du et spørsmål?'
      }
    }
  }
}

export default componentsLocaleNn
